
const m = window.require("@ember/object/core");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
